export interface ZipCodeFlagListModel {
  country: string;
  icon: string;
  mask: string;
}

export const ZipFlagListOptions: ZipCodeFlagListModel[] = [
  {
    country: 'Brasil',
    icon: 'flag_br_ico',
    mask: '00000-000'
  }
];
